import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2.5 font-heading text-2xl font-bold text-foreground-950">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-50 text-primary-600">
            <i className={`${icon} text-xl`}></i>
          </span>
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}